/* ============================================================
   BNDT COLLECTION PAGE JS
   ============================================================ */
(function () {
  'use strict';

  var fiveXExpires = parseInt(sessionStorage.getItem('bndt_5x_expires') || '0', 10);
  const SWEEP_MULT = (fiveXExpires && Date.now() < fiveXExpires) ? 5 : 1;

  /* --- Filter Chips --- */
  function initFilters() {
    const chips = document.querySelectorAll('.coll__filter-chip');
    const cards = document.querySelectorAll('.coll__card[data-product-type]');
    if (!chips.length) return;

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');

        var filterType = chip.getAttribute('data-type');

        cards.forEach(function (card) {
          if (filterType === 'all') {
            card.style.display = '';
          } else {
            card.style.display = card.getAttribute('data-product-type') === filterType ? '' : 'none';
          }
        });
      });
    });
  }

  /* --- Card Swatch Switching --- */
  function initSwatches() {
    var swatches = document.querySelectorAll('.coll__card-swatch');
    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var card = swatch.closest('.coll__card');
        var allSwatches = card.querySelectorAll('.coll__card-swatch');
        allSwatches.forEach(function (s) { s.classList.remove('is-active'); });
        swatch.classList.add('is-active');

        var imgUrl = swatch.getAttribute('data-image');
        if (imgUrl) {
          var img = card.querySelector('.coll__card-img-wrap img');
          if (img) img.src = imgUrl;
        }

        var variantPrice = swatch.getAttribute('data-price');
        if (variantPrice) {
          var priceEl = card.querySelector('.coll__card-price');
          if (priceEl) priceEl.textContent = variantPrice;
        }

        // Update Quick Add button with selected variant
        var variantId = swatch.getAttribute('data-variant-id');
        var quickAddBtn = card.querySelector('.coll__card-quick-add');
        if (quickAddBtn && variantId) {
          quickAddBtn.setAttribute('data-variant-id', variantId);
        }
      });
    });
  }

  /* --- Quick Add to Cart --- */
  function initQuickAdd() {
    var buttons = document.querySelectorAll('.coll__card-quick-add');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        })
        .then(function (res) { return res.json(); })
        .then(function () {
          btn.classList.add('is-added');
          btn.innerHTML = '<svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"></polyline></svg>';
          setTimeout(function () { if (window.BNDT && window.BNDT.openCartDrawer) { window.BNDT.openCartDrawer(); } else { window.location.href = '/cart'; } }, 600);
        })
        .catch(function () {
          btn.disabled = false;
        });
      });
    });
  }

  /* --- Load More Pagination --- */
  function initLoadMore() {
    var btn = document.querySelector('.coll__load-more-btn');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var nextUrl = btn.getAttribute('data-next-url');
      if (!nextUrl) return;

      btn.textContent = 'Loading...';
      btn.disabled = true;

      fetch(nextUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newCards = doc.querySelectorAll('.coll__card');
          var grid = document.querySelector('.coll__grid');

          newCards.forEach(function (card) {
            grid.appendChild(card);
          });

          var newBtn = doc.querySelector('.coll__load-more-btn');
          if (newBtn) {
            btn.setAttribute('data-next-url', newBtn.getAttribute('data-next-url'));
            btn.textContent = 'Load More';
            btn.disabled = false;
          } else {
            btn.parentElement.style.display = 'none';
          }

          initSwatches();
          initQuickAdd();
        })
        .catch(function () {
          btn.textContent = 'Load More';
          btn.disabled = false;
        });
    });
  }

  /* --- Entry Pill Calculation --- */
  function initEntryPills() {
    var pills = document.querySelectorAll('.coll__card-entries[data-price-cents]');
    pills.forEach(function (pill) {
      var cents = parseInt(pill.getAttribute('data-price-cents'), 10) || 0;
      var dollars = Math.floor(cents / 100);
      var entries = dollars * SWEEP_MULT;
      var countEl = pill.querySelector('.coll__card-entries-count');
      if (countEl) countEl.textContent = entries;
    });
  }

  /* --- Sort Chips --- */
  function initSort() {
    var chips = document.querySelectorAll('.coll__sort-chip');
    if (!chips.length) return;

    // Set active chip from URL on page load
    var params = new URLSearchParams(window.location.search);
    var currentSort = params.get('sort_by') || 'manual';
    chips.forEach(function(chip) {
      chip.classList.toggle('is-active', chip.getAttribute('data-sort') === currentSort);
    });

    chips.forEach(function(chip) {
      chip.addEventListener('click', function() {
        var sort = chip.getAttribute('data-sort');
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort);
        window.location.href = url.toString();
      });
    });
  }

  /* --- Init All --- */
  document.addEventListener('DOMContentLoaded', function () {
    initFilters();
    initSort();
    initSwatches();
    initQuickAdd();
    initLoadMore();
    initEntryPills();
  });
})();
